
export enum ProfileAccessTypeLocaleId {
    FullAccess = 'dashboard.fullAccess',
    Limited = 'dashboard.limited',
}
